var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"shared-button",class:{
    'shared-button-size-sm': _vm.size === 'sm',
    'shared-button-size-md': _vm.size === 'md',
    'shared-button-radius-8': _vm.borderRadius8,
  },attrs:{"color":_vm.color,"loading":_vm.loading,"disabled":_vm.disabled,"elevation":_vm.elevation,"height":_vm.height,"block":_vm.block},on:{"click":function($event){return _vm.$emit('handleClick')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }